export default __webpack_public_path__ + "static/media/BB_41.8b26c4de.png";